import {Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {AmChartsService} from '@amcharts/amcharts3-angular';
import {Subscription} from 'rxjs';
import {NoResults} from '../../../models/no-results';

@Component({
  selector: 'cmp-chart-amchart',
  template: `<span [hidden]="loading && !isError" #graphElement></span>
<ng-container *ngIf="loading && !isError">
  <!-- TODO by xinaski-->
  <div class="">
    <div class="">
      <div class="inner text-center">
        <i class="fa fa-spinner text-primary fa-2x fa-pulse fa-fw"></i>
        <h3 class="no-results text-primary">Loading</h3>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="((!existChart && !loading) || isError)">
  <cmp-not-results
    [noResults]="noResults">
  </cmp-not-results>
</ng-container>



`,
  styles: [`.errorMessage{font-size:15px!important}.outer{display:table;position:absolute;height:100%;width:100%}.middle{display:table-cell;vertical-align:middle}.inner{margin-left:auto;margin-right:auto}`]
})
export class ChartAmchartComponent implements OnInit, OnDestroy {
  _loading = false;
  divCreated: any;
  amchart: any;
  subscriptionList: Subscription[] = [];
  chartSubscription: Subscription;
  existChart = false;
  chart: any = {};

  isError: boolean;
  _noResults: NoResults;

  @ViewChild('graphElement') private graphElement: ElementRef;

  @Input()
  set noResults(noResults: NoResults) {
    if (noResults) {
      this._noResults = noResults;
      const {isError} = noResults;
      this.isError = isError != null ? isError : this.isError;
    }
  }

  get noResults() {
    return this._noResults;
  }

  @Input()
  set loading(its) {
    this._loading = its;
  }

  get loading() {
    return this._loading;
  }

  @Input()
  set chartData(its) {
    if (its && !this.loading && !this.isError) {
      this.getNewData(its);
    }
  }

  constructor(private AmCharts: AmChartsService,
              private renderer: Renderer2,) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.unsubscribeList();
    if (this.amchart) {
      this.AmCharts.destroyChart(this.amchart);
    }
  }

  unsubscribeList() {
    this.subscriptionList.forEach(subscription => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
    this.unsubscribe();
  }

  unsubscribe() {
    if (this.chartSubscription) {
      this.chartSubscription.unsubscribe();
    }
  }

  getNewData(data) {
    if (!this.existChart && !this.loading && !this.isError && this.AmCharts && data.graph && data.data) {
      this.divCreated = this.renderer.createElement('div');
      this.renderer.setAttribute(this.divCreated, 'id', data.divId);
      this.renderer.setStyle(this.divCreated, 'width', data.width);
      this.renderer.setStyle(this.divCreated, 'height', data.height);
      this.renderer.appendChild(this.graphElement.nativeElement, this.divCreated);
      this.chart = data.buildData;
      this.amchart = this.AmCharts.makeChart(data.divId, this.chart);
      this.existChart = true;
    }
  }

  subscribeToChartResize() {
    // this.chartSubscription = this.scoringChartResizeService.resizePrintChart$
    //   .filter(Boolean)
    //   .subscribe(() => {
    //     this.resizePrintChart();
    //   });
  }

  resizePrintChart() {
    // const chart = this.amchart;
    // if ('matchMedia' in window) {
    //   // Chrome, Firefox, and IE 10 support mediaMatch listeners
    //   window.matchMedia('print').addListener(function (media) {
    //     chart.validateNow();
    //   });
    // } else {
    //   // IE and Firefox fire before/after events
    //   window.onbeforeprint = function () {
    //     chart.validateNow();
    //   };
    // }
  }
}
